/**
 * @desc: - 遮罩 
 * @param  {[bool]} display: [是否显示遮罩]
 * @author: circle
 */
import React from 'react';
export default class OVERLAY extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    let {display} = this.props;
    const className = display ? 'overlay-mask' : '';
    return (
      <div className={className}></div>
    );
  }
}